import React, { createContext, useState, useMemo, useEffect } from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { getTheme, useThemes } from './theme';
import { useDispatch, useSelector } from 'react-redux';
import { setUserPreference } from '../../redux/reducers/UserPreference';


export const ThemeProviders = ({ children }) => {
  let dispatch = useDispatch()
  let userPreference = useSelector(
    (state) => state?.userPrefrenceandReducer?.userPreference
  );
  let mode = userPreference?.find(elem => elem?.attributetypecd == 'SelectedTheme')?.attributevalue
  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "MainTheme" && JSON.parse(event.newValue)?.tmId !== undefined) {
        const updatedPreferences = userPreference.map(preference => {
          if (preference.attributetypecd === 'SelectedTheme') {
            return {
              ...preference,
              attributevalue: JSON.parse(event.newValue).tmId
            };
          }
          return preference;
        });
        dispatch(setUserPreference(updatedPreferences))
        localStorage.removeItem("MainTheme");
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const theme = useMemo(() => getTheme(mode), [mode]);

  return (
    <ThemeProvider theme={theme}>
      {children}
    </ThemeProvider>
  );
};
